import { render, staticRenderFns } from "./ReplicacaoCliente.vue?vue&type=template&id=067059b8"
import script from "./ReplicacaoCliente.vue?vue&type=script&lang=js"
export * from "./ReplicacaoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports